import ChartingConfiguration from '@/components/charting/ChartingConfiguration';
import React from 'react';
import { useDispatch } from 'react-redux';
import { completed } from '@/actions/helpers';
import { WIDGET_CONFIGURATION_UPDATED } from '@/actions/constants';
import {
  selectChartConfiguration,
  selectDataTable,
  selectChartType,
  selectChartWidgetIndex,
  updateChartConfiguration,
  selectMetrics,
  selectDimensions,
} from '@/features/dashboard/dashboardSlice';
import { useAppSelector } from '@/store/hooks';
import {
  getDataTableForMetricsAndDimensions,
  validateDataTable,
} from '@/features/dashboard/utils';

export const DashboardWidgetChartConfiguration: React.FC = () => {
  const dispatch = useDispatch();

  const chartWidgetIdx = useAppSelector(selectChartWidgetIndex);
  const chartConfig = useAppSelector(selectChartConfiguration);
  const dataTable = useAppSelector(selectDataTable);
  const displayType = useAppSelector(selectChartType);
  const metrics = useAppSelector(selectMetrics);
  const dimensions = useAppSelector(selectDimensions);

  const updateConfig = (newChartConfig: Nullable<unknown[]>) => {
    // TODO updating the widget just for testing. Should be saved on "Done"
    dispatch(updateChartConfiguration(newChartConfig));
    dispatch(
      completed(WIDGET_CONFIGURATION_UPDATED, {
        widgetIndex: chartWidgetIdx,
        chartConfig: newChartConfig,
      }),
    );
  };

  const isReady = chartWidgetIdx !== null && !!dataTable && !!displayType;

  if (!isReady) return null;

  const configuredDataTable = getDataTableForMetricsAndDimensions(
    dataTable,
    (dimensions || []).concat(metrics || []),
  );

  const isValid = validateDataTable(
    configuredDataTable.headings(),
    displayType,
  );

  if (!isValid) return null;

  return (
    <ChartingConfiguration
      chartingOptions={chartConfig}
      showOnboarding={false}
      dataTable={configuredDataTable}
      headings={configuredDataTable.headings()}
      dataPresentation={displayType === 'stacked' ? 'pie' : displayType}
      onUpdateChartingOptions={updateConfig}
    />
  );
};
